import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import SchoolIcon from "@mui/icons-material/School";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExperienceIcon from 'icons/ExperienceIcon';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentIcon from '@mui/icons-material/Assignment';

export const PROFILE_NAV_ITEMS = [
  { id: "position", label: "Current Position", icon: <WorkOutlineIcon /> },
  { id: "experience", label: "Experience", icon: <ExperienceIcon /> },
  { id: "education", label: "Education", icon: <SchoolIcon /> },
  { id: "reimbursement", label: "Reimbursement", icon: <ReceiptLongIcon /> },
  { id: "exported", label: "Exported Procedures", icon: <AssignmentIcon /> },
  { id: "dashboard", label: "Dashboard", icon: <DashboardIcon /> },
];